import { render, staticRenderFns } from "./DalinkApp.vue?vue&type=template&id=50015c0f"
import script from "./DalinkApp.vue?vue&type=script&setup=true&lang=js"
export * from "./DalinkApp.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DalinkApp.vue?vue&type=style&index=0&id=50015c0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports